import { sendMessageToParent } from 'src/lib/messages';

export const ANYCOPY_WIDGET_MESSAGE_TYPES = {
  anycopyWidgetResize: 'ANYCOPY_WIDGET_RESIZE',
  anycopyWidgetScrollTo: 'ANYCOPY_WIDGET_SCROLL_TO',
  anycopyWidgetLaded: 'ANYCOPY_WIDGET_LOADED',
  anycopyWidgetInit: 'ANYCOPY_WIDGET_INIT',
};

export const sendResizeMessage = (el) => {
  sendMessageToParent({
    type: ANYCOPY_WIDGET_MESSAGE_TYPES.anycopyWidgetResize,
    height: el?.scrollHeight,
  });
};

const sendScrollToMessage = (scrollToTopValue, learnMore = false) => {
  sendMessageToParent({
    type: ANYCOPY_WIDGET_MESSAGE_TYPES.anycopyWidgetScrollTo,
    scrollToTopValue,
    learnMore,
  });
};

export const scrollToElement = (el) => {
  el.scrollIntoView({
    block: 'start',
    behavior: 'smooth',
  });

  sendScrollToMessage(el.getBoundingClientRect().top);
};

export const scrollToValue = (value) => {
  sendScrollToMessage(value, true);
};

export const sendWidgetLoadedEvent = () => {
  sendMessageToParent({
    type: ANYCOPY_WIDGET_MESSAGE_TYPES.anycopyWidgetLaded,
  });
};
